/**
 * @module app.shared
 */


export class NotFound {

    constructor() { }

}
